module.exports = __webpack_public_path__ + "static/media/xueshengjie1.781cc1df.jpg";